import { PesquisarUsuarioComponent } from './../view/usuario/pesquisar-usuario/pesquisar-usuario.component';
import { Routes } from '@angular/router';
import { AuthGuardService } from '../service/autenticacao/auth-guard.service';
import { URL } from '../tools/URL';
import { HomeComponent } from '../view/home/home.component';
import { CriticaComponent } from '../view/manifestos/critica';
import { DenunciaComponent } from '../view/manifestos/denuncia';
import { ElogioComponent } from '../view/manifestos/elogio/elogio.component';
import { InformacaoComponent } from '../view/manifestos/informacao/informacao.component';
import { ReclamacaoComponent } from '../view/manifestos/reclamacao';
import { SolicitacaoComponent } from '../view/manifestos/solicitacao/solicitacao.component';
import { SugestaoComponent } from '../view/manifestos/sugestao/sugestao.component';
import { LgpdComponent } from '../view/manifestos/lgpd/lgpd.component';
import { SucessoComponent } from '../view/sucesso/sucesso.component';
import { CadastroComponent } from '../view/usuario/cadastro/cadastro.component';
import { LoginComponent } from '../view/usuario/login/login.component';
import { SucessoCadastroUsuarioComponent } from './../view/sucesso-cadastro-usuario/sucesso-cadastro-usuario.component';
import { EsqueciSenhaEmailComponent } from '../view/usuario/esqueci-senha-email/esqueci-senha-email.component';
import { RedefinirSenhaEmailComponent } from '../view/usuario/redefinir-senha-email/redefinir-senha-email.component';
import { RedefinirSenhaComponent } from './../view/usuario/redefinir-senha/redefinir-senha.component';
import { ConsultaComponent } from '../view/manifestos/consulta/consulta.component';
import { HomeOperadorComponent } from '../view/usuario-interno/home/home-operador.component';
import { CadastroManifestoOperadorComponent } from '../view/usuario-interno/operador/manifesto/cadastro/cadastro-manifesto-operador.component';
import { OPERADOR_ROLE, GESTOR_ROLE } from '../tools/Roles';
import { PesquisaManifestoOperadorComponent } from '../view/usuario-interno/operador/manifesto/pesquisa/pesquisa-manifesto-operador.component';
import { RespostaManifestoOperadorComponent } from '../view/usuario-interno/operador/manifesto/resposta/resposta-manifesto-operador.component';
import { ManifestoPorUsuarioComponent } from '../view/usuario-interno/gestor/relatorio/manifesto-por-usuario/manifesto-por-usuario.component';
import { ManifestoPorOperadorComponent } from '../view/usuario-interno/gestor/relatorio/manifesto-por-operador/manifesto-por-operador.component';
import { ManifestoPorTemaComponent } from '../view/usuario-interno/gestor/relatorio/manifesto-por-tema/manifesto-por-tema.component';
import { SemPermissaoComponent } from '../view/usuario-interno/sem-permissao/sem-permissao.component';
import { PesquisaManifestoUsuarioComponent } from '../view/usuario/pesquisa/pesquisa-manifesto-usuario.component';
import { AtivarContaComponent } from './../view/usuario/ativar-conta/ativar-conta.component';
import { DenunciaAnonimaComponent } from '../view/manifestos/denuncia-anonima/denuncia-anonima.component';
import { DenunciaAnonimaAvisoComponent } from '../view/manifestos/denuncia-anonima/denuncia-anonima-aviso/denuncia-anonima-aviso.component';
import { DenunciaAnonimaRecomendacoesComponent } from '../view/manifestos/denuncia-anonima/denuncia-anonima-recomendacoes/denuncia-anonima-recomendacoes.component';
import { DenunciaAnonimaSucessoComponent } from '../view/manifestos/denuncia-anonima/denuncia-anonima-sucesso/denuncia-anonima-sucesso.component';
import { HomeGovbrComponent } from '../view/home/home-govbr/home-govbr.component';
import { CpeComponent } from '../view/manifestos/cpe/cpe.component';
import {FaleComRhComponent} from '../view/manifestos/fale-com-rh/fale-com-rh.component';
import { LaiComponent } from '../view/manifestos/lai/lai.component';

const SLASH = '/';

export const routes: Routes = [
  { path: URL.HOME,                     component: HomeComponent, canActivate: [AuthGuardService] },
  { path: URL.HOME_GOVBR,               component: HomeGovbrComponent },
  { path: URL.LOGIN,                    component: LoginComponent },
  { path: URL.USUARIO,                  component: CadastroComponent },
  { path: URL.EDITAR_USUARIO,           component: CadastroComponent },
  { path: URL.PESQUISAR_MANIFESTO_USUARIO,         component: PesquisaManifestoUsuarioComponent },
  {
    path: URL.EDITAR_USUARIO + SLASH + ':id',
    component: CadastroComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [OPERADOR_ROLE, GESTOR_ROLE]
    }
  },
  { path: URL.SUCESSO_FORM,             component: SucessoComponent },
  { path: URL.SUCESSO_USER,             component: SucessoCadastroUsuarioComponent },
  { path: URL.RECLAMACAO,               component: ReclamacaoComponent, canActivate: [AuthGuardService] },
  { path: URL.CPE,                      component: CpeComponent, canActivate: [AuthGuardService] },
  {
    path: URL.FALE_COM_RH,
    component: FaleComRhComponent,
    canActivate: [AuthGuardService],
    data: {
      requireGovBr: true
    }
  },
  {
    path: URL.LAI,
    component: LaiComponent,
    canActivate: [AuthGuardService]
  },
  { path: URL.DENUNCIA,                 component: DenunciaComponent, canActivate: [AuthGuardService] },
  { path: URL.CRITICA,                  component: CriticaComponent, canActivate: [AuthGuardService] },
  { path: URL.ELOGIO,                   component: ElogioComponent, canActivate: [AuthGuardService] },
  { path: URL.SOLICITACAO,              component: SolicitacaoComponent, canActivate: [AuthGuardService] },
  { path: URL.SUGESTAO,                 component: SugestaoComponent, canActivate: [AuthGuardService] },
  { path: URL.LGPD,                     component: LgpdComponent, canActivate: [AuthGuardService] },
  { path: URL.INFORMACAO,               component: InformacaoComponent, canActivate: [AuthGuardService] },
  { path: URL.CONSULTA,                 component: ConsultaComponent, canActivate: [AuthGuardService] },
  { path: URL.ESQUECI_SENHA_EMAIL,      component: EsqueciSenhaEmailComponent },
  { path: URL.REDEFINIR_SENHA_EMAIL,    component: RedefinirSenhaEmailComponent },
  { path: URL.REDEFINIR_SENHA,          component: RedefinirSenhaComponent },
  { path: URL.PESQUISAR_USUARIO,        component: PesquisarUsuarioComponent },
  { path: URL.USUARIO_INTERNO_SEM_PERMISSAO,       component: SemPermissaoComponent },
  { path: URL.ATIVAR_CONTA,             component: AtivarContaComponent },
  { path: URL.DENUNCIA_ANONIMA,         component: DenunciaAnonimaComponent},
  { path: URL.DENUNCIA_ANONIMA_AVISO,   component: DenunciaAnonimaAvisoComponent},
  { path: URL.DENUNCIA_ANONIMA_RECOMENDACOES,  component: DenunciaAnonimaRecomendacoesComponent},
  { path: URL.DENUNCIA_ANONIMA_SUCESSO,  component: DenunciaAnonimaSucessoComponent},
  {
    path: URL.USUARIO_INTERNO,
    component: HomeOperadorComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [OPERADOR_ROLE, GESTOR_ROLE]
    }
  },
  {
    path: URL.MANIFESTO_OPERADOR,
    component: CadastroManifestoOperadorComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [OPERADOR_ROLE, GESTOR_ROLE]
    }
  },
  {
    path: URL.PESQUISA_MANIFESTO_OPERADOR,
    component: PesquisaManifestoOperadorComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [OPERADOR_ROLE, GESTOR_ROLE]
    }
  },
  {
    path: URL.MANIFESTO_OPERADOR + SLASH + ':tipoManifesto' + SLASH + ':id',
    component: CadastroManifestoOperadorComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [OPERADOR_ROLE, GESTOR_ROLE]
    }
  },
  // {
  //   path: URL.RESPOSTA_MANIFESTO_OPERADOR + SLASH + ':tipoManifesto' + SLASH + ':id',
  //   component: RespostaManifestoOperadorComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     roles: [OPERADOR_ROLE]
  //   }
  // },
  {
    path: URL.RELATORIO_POR_USUARIO,
    component: ManifestoPorUsuarioComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [GESTOR_ROLE]
    }
  },
  {
    path: URL.RELATORIO_POR_OPERADOR,
    component: ManifestoPorOperadorComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [GESTOR_ROLE]
    }
  },
  {
    path: URL.RELATORIO_POR_TEMA,
    component: ManifestoPorTemaComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [GESTOR_ROLE]
    }
  }
];
